module.exports = {"341503001":"鼓楼街道","341503002":"西市街道","341503003":"小华山街道","341503100":"苏埠镇","341503101":"韩摆渡镇","341503102":"新安镇","341503103":"顺河镇","341503104":"独山镇","341503105":"石婆店镇","341503106":"城南镇","341503107":"丁集镇","341503108":"固镇镇","341503109":"徐集镇","341503110":"分路口镇","341503111":"江家店镇","341503200":"单王乡","341503201":"青山乡","341503202":"石板冲乡","341503203":"西河口乡","341503204":"平桥乡","341503205":"罗集乡","341503206":"狮子岗乡","341503400":"六安市裕安区经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/341503.json
// module id = 1138
// module chunks = 0